import React, { Component } from 'react';
import PropTypes from 'prop-types';
import copy from 'clipboard-copy';
import { Redirect } from 'react-router';
import { Button, Container, Image } from 'react-bootstrap';
import fav from '../images/blackHeartIcon.svg';
import notFav from '../images/whiteHeartIcon.svg';
import share from '../images/shareIcon.svg';
import { addFoodToFavorite, continueRecipe, fetchFoodApiById, fetchDrinkRecomendation,
  getIngredientList, isFavoriteRecipe, recipeIsDone } from '../helpers';
import RecomendationCard from './RecomendationCard';
import './generico.css';
import IngredientList from './IngredientList';

class GenericoComidas extends Component {
  constructor() {
    super();
    this.state = {
      redirectTo: '',
      currentRecipe: '',
      currentVideo: '',
      ingredientList: {},
      recomendations: [],
      isThisRecipeDone: false,
      continueThisRecipe: false,
      favoriteRecipe: false,
    };
    this.fetchFoodRecipe = this.fetchFoodRecipe.bind(this);
    this.redirectToPage = this.redirectToPage.bind(this);
    this.fetchApi = this.fetchApi.bind(this);
    this.favoriteThisItem = this.favoriteThisItem.bind(this);
  }

  componentDidMount() {
    this.fetchApi();
  }

  fetchApi() {
    this.setState({ redirectTo: '' });
    const { match: { params: { id } } } = this.props;
    this.fetchFoodRecipe(id);
  }

  async fetchFoodRecipe(foodId) {
    const recipe = await fetchFoodApiById(foodId);
    const ingredients = getIngredientList(recipe);
    const recomendation = await fetchDrinkRecomendation();
    const youtubeVideo = recipe ? recipe.strYoutube.replace('watch?v=', 'embed/') : '';
    const finishedRechipe = recipeIsDone(foodId);
    const alreadyStartedThisRecipe = continueRecipe(foodId, 'comidas');
    const isFavorite = isFavoriteRecipe(foodId);
    this.setState({
      ingredientList: ingredients,
      recomendations: recomendation,
      currentVideo: youtubeVideo,
      currentRecipe: recipe,
      displayShareMesage: false,
      isThisRecipeDone: finishedRechipe,
      continueThisRecipe: alreadyStartedThisRecipe,
      favoriteRecipe: isFavorite,
    });
  }

  share() {
    copy(window.location);
    const SHOW_TIME = 3000;
    this.setState({ displayShareMesage: true }, () => {
      setTimeout(() => this.setState({ displayShareMesage: false }), SHOW_TIME);
    });
  }

  redirectToPage(page) {
    this.setState({ redirectTo: page });
  }

  favoriteThisItem() {
    const { currentRecipe } = this.state;
    const done = addFoodToFavorite(currentRecipe, 'comida');
    this.setState({ favoriteRecipe: done });
  }

  render() {
    const { currentRecipe, currentVideo, isThisRecipeDone,
      ingredientList, recomendations, displayShareMesage,
      continueThisRecipe, redirectTo, favoriteRecipe } = this.state;
    const { match: { params: { id } } } = this.props;

    if (redirectTo) {
      return <Redirect to={ redirectTo } />;
    }

    return (
      <div className="recipe-detail-wrapper">
        <Container>
          <div className="recipe-detail-header">
            <div className="recipe-detail-photo-wrapper">
              <Image
                src={ currentRecipe.strMealThumb }
                alt={ `Foto de ${currentRecipe.strMeal}` }
                className="linkImage recipe-detail-photo"
                data-testid="recipe-photo"
              />
            </div>
            
            <div className="recipe-detail-meta">
              <span className="recipe-detail-badge" data-testid="recipe-category">
                {currentRecipe.strCategory}
              </span>
              <h1 className="recipe-detail-title" data-testid="recipe-title">
                {currentRecipe.strMeal}
              </h1>

              <div className="recipe-detail-actions">
                <button
                  className="recipe-button"
                  type="button"
                  aria-label="Compartilhar receita"
                  onClick={ () => this.share() }
                >
                  <img
                    src={ share }
                    alt="Compartilhar"
                    data-testid="share-btn"
                  />
                </button>
                <button
                  className="recipe-button"
                  type="button"
                  aria-label={favoriteRecipe ? 'Remover dos favoritos' : 'Favoritar receita'}
                  onClick={ this.favoriteThisItem }
                >
                  <img
                    src={ favoriteRecipe ? fav : notFav }
                    alt="Favoritar"
                    data-testid="favorite-btn"
                  />
                </button>
              </div>

              {displayShareMesage && (
                <div className="share-toast" role="status" aria-live="polite">
                  ✨ Link copiado para a área de transferência!
                </div>
              )}
            </div>
          </div>

          <div className="recipe-detail-section">
            <h4>Ingredientes</h4>
            {ingredientList && <IngredientList ingredientList={ ingredientList } />}
          </div>

          <div className="recipe-detail-section">
            <h4>Modo de Preparo</h4>
            <div className="recipe-instructions-box" data-testid="instructions">
              {currentRecipe.strInstructions}
            </div>
          </div>

          {window.location.href.includes('comidas') && currentVideo && (
            <div className="recipe-detail-section">
              <h4>Vídeo Explicativo</h4>
              <div className="recipe-video-wrapper">
                <iframe
                  title="Vídeo demonstrativo de preparo"
                  className="linkVideo"
                  src={ currentVideo }
                  data-testid="video"
                />
              </div>
            </div>
          )}

          {recomendations && recomendations.length > 0 && (
            <div className="recipe-detail-section">
              <h4>Bebidas Recomendadas</h4>
              <RecomendationCard
                recomendations={ recomendations }
                redirectToPage={ this.redirectToPage }
              />
            </div>
          )}

          {!isThisRecipeDone && (
            <div className="recipe-start-sticky">
              <Button
                block
                className="default-button green start-recipe-btn-custom"
                type="button"
                data-testid="start-recipe-btn"
                onClick={ () => {
                  this.redirectToPage(`/comidas/${id}/in-progress`);
                } }
              >
                <span>{continueThisRecipe ? 'Continuar Receita &rarr;' : 'Iniciar Receita &rarr;'}</span>
              </Button>
            </div>
          )}
        </Container>
      </div>
    );
  }
}

GenericoComidas.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.string.isRequired,
    }),
  }).isRequired,
};

export default GenericoComidas;
